import type { DocumentType } from '../../graphql/generated/gql';
import { gql } from '../../graphql/generated/gql';
import entityPath from './entityPath';

const GROUP_PATH_GROUP_FRAGMENT = gql(`
  fragment groupPath_group on GroupFields {
    id
    name
  }
`);

function groupPath({
  id,
  name,
}: DocumentType<typeof GROUP_PATH_GROUP_FRAGMENT>) {
  return `/groups/${entityPath(name, id)}`;
}

export default groupPath;
